import React, { useState, useEffect } from "react";
import "./Statistics.css";
import student from "../../Assets/vectors/Icons/student.svg";
import alumni from "../../Assets/vectors/Icons/alumni.svg";
import teacher from "../../Assets/vectors/Icons/teacher.svg";
import time from "../../Assets/vectors/Icons/time.svg";
import { Spring } from "react-spring/renderprops";
import { useSpring, animated } from "react-spring";

const calc = (x, y) => [
  -(y - window.innerHeight / 2) / 20,
  (x - window.innerWidth / 2) / 20,
  1.05,
];
const trans = (x, y, s) =>
  `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`;

export default function Statistics(props) {
  const [number, setNumber] = useState({
    s: 0,
    t: 0,
    a: 0,
    y: 0,
  });
  useEffect(() => {
    if (props.isVisible) {
      setNumber({
        s: 80,
        t: 14,
        a: 100,
        y: 2014,
      });
    } else {
      setNumber({
        s: 0,
        t: 0,
        a: 0,
        y: 0,
      });
    }
  }, [props]);

  const [one, setOne] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 5, tension: 350, friction: 40 },
  }));
  const [two, setTwo] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 5, tension: 350, friction: 40 },
  }));
  const [three, setThree] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 5, tension: 350, friction: 40 },
  }));
  const [four, setFour] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 5, tension: 350, friction: 40 },
  }));

  return (
    <div className="statistics">
      <h2 className="mb05">Statistics</h2>
      <h1 className="mb2 bigHeader">
        We Are Committed To Educate & Nurture <br /> Your Children.
      </h1>
      <div className="grid gridFr statisticsContainer">
        <animated.div
          className="box"
          onMouseMove={({ clientX: x, clientY: y }) =>
            setOne({ xys: calc(x, y) })
          }
          onMouseLeave={() => setOne({ xys: [0, 0, 1] })}
          style={one && one.xys && { transform: one.xys.interpolate(trans) }}
        >
          <img src={time} alt="" />

          <div>
            <Spring
              from={{ number: 0 }}
              to={{ number: number.y }}
              delay={500}
              config={{ tension: 20, friction: 10, precision: 10 }}
            >
              {(prop) => <h1>{Math.floor(prop.number)}</h1>}
            </Spring>
            <b>Year Founded</b>
          </div>
        </animated.div>
        <animated.div
          className="box"
          onMouseMove={({ clientX: x, clientY: y }) =>
            setTwo({ xys: calc(x, y) })
          }
          onMouseLeave={() => setTwo({ xys: [0, 0, 1] })}
          style={two && two.xys && { transform: two.xys.interpolate(trans) }}
        >
          <img src={student} alt="" />
          <div>
            <Spring
              from={{ number: 0 }}
              to={{ number: number.s }}
              delay={500}
              config={{ tension: 10, friction: 5, precision: 1 }}
            >
              {(prop) => <h1>{Math.floor(prop.number)}+</h1>}
            </Spring>
            <b>Current Students</b>
          </div>
        </animated.div>
        <animated.div
          className="box"
          onMouseMove={({ clientX: x, clientY: y }) =>
            setThree({ xys: calc(x, y) })
          }
          onMouseLeave={() => setThree({ xys: [0, 0, 1] })}
          style={
            three && three.xys && { transform: three.xys.interpolate(trans) }
          }
        >
          <img src={teacher} alt="" />
          <div>
            <Spring
              from={{ number: 0 }}
              to={{ number: number.t }}
              delay={500}
              config={{ tension: 5, friction: 5, precision: 1 }}
            >
              {(prop) => <h1>{Math.floor(prop.number)}+</h1>}
            </Spring>
            <b>Certified Teachers</b>
          </div>
        </animated.div>
        <animated.div
          className="box"
          onMouseMove={({ clientX: x, clientY: y }) =>
            setFour({ xys: calc(x, y) })
          }
          onMouseLeave={() => setFour({ xys: [0, 0, 1] })}
          style={four && four.xys && { transform: four.xys.interpolate(trans) }}
        >
          <img src={alumni} alt="" />
          <div>
            <Spring
              from={{ number: 0 }}
              to={{ number: number.a }}
              delay={500}
              config={{ tension: 10, friction: 5, precision: 1 }}
            >
              {(prop) => <h1>{Math.floor(prop.number)}+</h1>}
            </Spring>
            <b>Already Educated</b>
          </div>
        </animated.div>
      </div>
    </div>
  );
}
